var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoneyOpacity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 62.109,
    height: 62.109,
    viewBox: "0 0 62.109 62.109",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#efefef",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#efefef",
    stopOpacity: 0.102
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-12.863 -12.863)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.863 12.863)",
    stroke: "#fff",
    strokeWidth: 2,
    fill: "url(#a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 31.055,
    cy: 31.055,
    r: 31.055,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.055,
    cy: 31.055,
    r: 30.055,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.314 26.516)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.114-357.182H151.883c-.589,0-.591,0-.591-.609q0-8.2,0-16.4a17.386,17.386,0,0,0-.541-3.256c-.306-1.626-.648-3.244-.987-4.863-.071-.339-.018-.492.366-.57q9.354-1.909,18.7-3.848l15.8-3.265c1.8-.372,3.609-.733,5.408-1.124.362-.079.474.037.54.364q1.037,5.162,2.09,10.319.9,4.427,1.8,8.854c.122.594.125.593-.45.718-1.1.239-1.1.239-1.1,1.353q0,5.879,0,11.756c0,.569,0,.571-.576.571Zm-.01-1.083h19.109c.641,0,.642,0,.642-.645v-17.209c0-.067-.005-.136,0-.2.027-.3-.088-.461-.41-.431-.132.013-.266,0-.4,0q-17.788,0-35.574,0c-.879,0-1.758-.005-2.639.036-.463.022-.47.165-.47.51q.01,8.666,0,17.331c0,.6,0,.6.589.6Zm13.962-19.555c1.871,0,3.74-.011,5.609.008.388,0,.446-.122.375-.47q-1.152-5.59-2.275-11.187c-.085-.422-.248-.472-.627-.392q-4.915,1.039-9.838,2.047-10.39,2.147-20.78,4.287-3.568.736-7.14,1.458c-.33.066-.471.162-.384.544.251,1.115.469,2.237.679,3.361a.36.36,0,0,0,.474.339c.33-.05.165-.294.138-.441-.178-.952-.364-1.9-.571-2.848-.064-.293.009-.415.3-.473,1.491-.3,2.98-.615,4.47-.922.1-.021.247-.068.3.029a1.441,1.441,0,0,1,.185.812c-.018.217-.263.194-.422.228-1.069.23-2.141.457-3.213.669-.314.062-.464.15-.364.529a17.4,17.4,0,0,1,.4,1.935c.059.4.24.5.613.494q4.869-.018,9.736,0c.387,0,.526-.118.59-.5A7.948,7.948,0,0,1,174.93-384.4a7.852,7.852,0,0,1,5.056,6c.125.569.106.574.672.574Zm-16.13,0a.316.316,0,0,0-.042-.1,2.125,2.125,0,0,1,.364-2.983c.383-.288.523-.544.348-.99-.047-.118-.131-.316.037-.405a1.264,1.264,0,0,1,.762-.193c.247.039.2.327.23.508a.487.487,0,0,0,.531.471,3.251,3.251,0,0,1,1.022.173c.1.038.251.051.262.157a1.555,1.555,0,0,1-.263.787c-.086.191-.252.083-.388.05a2.195,2.195,0,0,0-1.816.169c-.622.4-.705,1.347-.128,1.627a7.432,7.432,0,0,0,2.926.761c1.6.067,3.2.01,4.8.025.351,0,.423-.09.354-.442a6.935,6.935,0,0,0-8.376-5.447,6.947,6.947,0,0,0-5.24,5.5c-.052.328.038.394.337.392,1.348-.012,2.7-.005,4.045-.007C169.778-377.766,169.865-377.738,169.936-377.817Z",
    transform: "translate(-149.74 391.141)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.075-377.328c.748,0,1.5.009,2.243,0,.3-.005.4.113.4.4-.006,1.376-.012,2.751,0,4.126,0,.444-.276.4-.561.407s-.52-.019-.514-.415c.015-1-.01-2,.011-3,.009-.375-.094-.516-.491-.507-1.107.025-2.217-.005-3.324.015-.381.008-.446-.172-.439-.487s0-.555.43-.54C184.579-377.31,185.328-377.328,186.075-377.328Z",
    transform: "translate(-147.38 392.502)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.057-361c-.746,0-1.494-.018-2.241.008-.411.014-.41-.225-.411-.512s.005-.521.41-.515c1.133.018,2.267,0,3.4.012.329,0,.446-.1.441-.435-.016-1-.009-2,0-3,0-.443.056-.469.571-.482.346-.011.505.087.5.472-.019,1.333-.016,2.667,0,4,0,.35-.116.469-.465.459C187.524-361.018,186.791-361,186.057-361Z",
    transform: "translate(-147.38 393.663)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.914-384.431c-.271.047-.264-.172-.3-.329-.207-.978-.415-1.956-.6-2.937-.064-.339-.158-.477-.549-.386-1.09.252-2.194.443-3.287.686-.315.07-.434-.013-.5-.313-.135-.659-.141-.654.506-.781,1.359-.267,2.72-.531,4.076-.821.352-.075.5,0,.571.363.252,1.322.535,2.638.8,3.957C187.731-384.552,187.571-384.431,186.914-384.431Z",
    transform: "translate(-147.518 391.28)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.07-368.721a7.951,7.951,0,0,1-7.958,7.9,8.05,8.05,0,0,1-7.962-8.021,7.948,7.948,0,0,1,7.988-7.906A7.984,7.984,0,0,1,179.07-368.721Zm-1.085-.058a6.872,6.872,0,0,0-6.854-6.943,6.877,6.877,0,0,0-6.92,6.877,6.847,6.847,0,0,0,6.838,6.949A6.825,6.825,0,0,0,177.986-368.779Z",
    transform: "translate(-149.148 392.829)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.562-364.022c-.335.064-.417-.137-.419-.464,0-.79-.013-.794-.771-.963a4.993,4.993,0,0,1-.795-.268.374.374,0,0,1-.251-.558c.2-.534.181-.54.7-.316a3.326,3.326,0,0,0,1.641.277,1.292,1.292,0,0,0,1.186-.92,1.248,1.248,0,0,0-.57-1.31c-.581-.417-1.29-.573-1.894-.951a1.981,1.981,0,0,1-.7-2.922,2.115,2.115,0,0,1,1.2-.825.411.411,0,0,0,.343-.492c-.01-.134,0-.267,0-.4.006-.49.05-.517.526-.518.3,0,.382.136.388.414.013.771.022.77.764.944a3.256,3.256,0,0,1,.347.1c.565.2.57.246.369.8-.118.33-.27.346-.567.22a2.6,2.6,0,0,0-1.758-.18.968.968,0,0,0-.75.753.984.984,0,0,0,.381,1.031,3.724,3.724,0,0,0,.909.5,7.431,7.431,0,0,1,1.086.511,2.194,2.194,0,0,1,1.129,2.26,2.087,2.087,0,0,1-1.548,1.81c-.367.122-.5.293-.448.654a2.5,2.5,0,0,1,0,.36C171.047-364.052,171.019-364.023,170.562-364.022Z",
    transform: "translate(-148.752 392.99)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.395-377.328c.748,0,1.5.016,2.244-.005.4-.012.414.224.413.514s0,.519-.414.512c-1.122-.022-2.245,0-3.366-.014-.346-.005-.47.093-.462.451.02,1-.011,2,.015,3.005.011.427-.2.477-.541.472s-.56-.022-.553-.462c.023-1.336.018-2.671,0-4.007-.005-.381.146-.48.5-.471C153.951-377.315,154.673-377.328,155.395-377.328Z",
    transform: "translate(-149.509 392.783)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.4-361c-.748,0-1.5-.011-2.243.005-.317.006-.42-.116-.418-.422.009-1.361.015-2.723,0-4.085-.005-.433.251-.421.548-.421s.552-.005.543.425c-.023.975-.008,1.949-.006,2.923,0,.56,0,.56.578.561,1.067,0,2.136.016,3.2-.009.409-.009.455.193.455.517s-.045.529-.456.513C156.865-361.025,156.129-361,155.4-361Z",
    transform: "translate(-149.509 393.664)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyOpacity);
export default __webpack_public_path__ + "static/media/moneyOpacity.48527e81f3636aaddbd534c3b2a79bc6.svg";
export { ForwardRef as ReactComponent };